export default __webpack_public_path__ + "austin_site_to_process_paths_eu.ab3d026f.csv";